<template>
    <div>
        <az-empty-state v-if="!dados || !dados.length" />

        <table class="table table-sm bg-white table-hover small cabecalho-fixo" v-else>
            <thead>
                <tr>
                    <th>Descrição</th>
                    <th>ANS</th>
                    <th>Contratos</th>
                    <th>Versão TISS</th>
                    <th>Planos</th>
                    <th>Profs</th>
                </tr>
            </thead>
            <tbody v-if="dados">
                <tr v-for="(oper, iox) in dados" :key="iox">
                    <td>
                        <a href="#" @click.prevent="$util.abrirOperadora(oper)" class="card-link">
                            {{ oper.st_operadora }}
                        </a>
                        <div class="text-muted" v-if="oper.empresa">
                            {{ $util.formatMask(oper.empresa.st_cnpj, 'cnpj') }}
                        </div>
                    </td>
                    <td>
                        {{ oper.st_registro_ans }}
                    </td>
                    <td>
                        <div v-for="(contrato, icx) in oper.contrato_operadoras" :key="icx">
                            <span class="text-muted">{{ contrato.st_descricao_arquivo_contrato }}</span>
                            {{ contrato.st_numero_prestador }}
                        </div>
                    </td>
                    <td>
                        <span v-if="oper.guia_operadora">
                            {{ oper.guia_operadora.st_versao_tiss }}
                        </span>
                    </td>
                    <td class="text-center">
                        {{ oper.planos_count }}
                    </td>
                    <td class="text-center">
                        {{ oper.medico_operadoras_count }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            dados: null, 
        }
    },

    components: { 
        AzEmptyState,
    },

    methods: { 
        load() { 
            this.$util.load(this, { 
                service: 'operadoras.index',
                parms: { 
                    valid: true, 
                }
            })
        }
    },

    mounted() { 
        this.load();
    }
}
</script>